<template>
  <div class="myupload">
     <el-upload 
        class="avatar-uploader"
        :on-preview="uploadPreview"
        :data="upload.data"
        :headers='headers'
        :action="upload.postURL"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :http-request='submitUpload'
        :before-upload="beforeAvatarUpload">
        <span>上传图片</span>
         <!-- :http-request='submitUpload' -->
        <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
      </el-upload>
      
  </div>
</template>
<script>
import axios from 'axios'
import Hub from "../utils/eventHub.js";
import { API__code,API_Common } from '../api/index.js'
export default {
    inject:['reload'],
    name:'upload',
    props: {
      picIdes:{
        type:String
      },
      fileList: {
        type: Array,
        default: () => {
          return [];
        }
      },
      limit: {
        type: Number,
        default: 20,
      },
     
      type: {
        type: Number,
      },
      msgFather : {
        type: Boolean       
      }
    },
    data() {
      return {
        picIded:'',
        headers:{
          'Content-Type': 'multipart/form-data'
        },
        upload: {
          fileList: this.fileList,
          picIds: [],
          postURL: API_Common.upload(),   //post地址
          dialogImageUrl: '',  // 文件地址
          dialogVisible: false,    // 上传文件loading
          data: {
            mode: 'save',    
            token:this.token,
            checkCode:this.checkCode,
            id:this.id,          
          }
        },
        imageUrl: '',
      };
    },
    created() {
      this.getCookie();
      this.multiple = this.limit <= 1 ? false : true;
    },

    mounted() {
      Hub.$on('handleUploadPicsReset', () => {
        this.upload.fileList = [];
        this.upload.picIds = [];
      });
    },

    beforeDestroy () {
      Hub.$off('handleUploadPicsReset');
    },
    
    methods: {
      submitUpload: function(content) {//自定义的上传图片的方法
          //1. 创建formData 利用AXIOS传递
          let formData = new FormData;
          formData.append('pic', content.file);
          formData.append('token', this.token);
          formData.append('checkCode', this.checkCode);
          formData.append('id', this.id);
          formData.append('oldpicid', this.picIded);
          formData.append('mode', 'save');
          let config = {
              'Content-Type': 'multipart/form-data'
          }
          let var_this = this;
          axios.post(this.upload.postURL, formData, config)
              .then(function(res) {
                  if (res.data.code == API__code.SUCCESS) {
                     content.onSuccess(res.data.data);
                      var_this.$message({
                          message: "上传成功",
                          type: 'success'
                      });
                  }
              })
              .catch(function(error) {
                  console.log(error);
              })
      },
      // 上传图片的回调
      uploadPreview(file) {
        var path = file.pic ? file.pic : file.response.data.pic;
        var imgtypess;
        if(path.indexOf("/")>0){//如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
            imgtypess=path.substring(path.lastIndexOf("/")+1,path.length);
        }
        var types = imgtypess.split('.');
        var imgtype = types[1];
        if (imgtype == "png" || imgtype == "jpeg" || imgtype == "bmp" || imgtype == "jpg"){ 
            window.open(path);
        }else{
            window.location.href= path;
        }
        this.upload.dialogImageUrl = file.url;
        this.upload.dialogVisible = true;
      },
      uploadSuccess(res, file, fileList) {
        this.upload.picIds.push(res.id);
        this.imageUrl = URL.createObjectURL(file.raw);
        var picPath =  res.pic;
        // var picPath = res.projectPath + res.pic;
        this.$emit('handleUploadSuccess', picPath);

        // this.$emit('handleUploadPicIds', response.pic);
      },
      beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        // const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isJPG && isLt2M;
      },
      //读取cookie
      getCookie: function() {
        this.id = sessionStorage.getItem('dnnypt_id');
        if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'dnnypt_token') {
                this.token = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == 'dnnypt_checkCode') {
                this.checkCode = arr2[1];
            }
            // else if (arr2[0] == 'dnnypt_id') {
            //     this.id = arr2[1];
            // }
          }
        }
      },
      ids:function(){
        this.picIded = this.picIdes;
      },
    },

    watch: {
      'fileList': function() {
        this.upload.fileList=[];
        this.upload.picIds = [];
        this.fileList.map( (item) => {
          this.upload.fileList.push(item);
          this.upload.picIds.push(item);
        });
        // this.$emit('handleUploadPicIds', this.upload.picIds);
      },
      picIdes(){
        this.ids();
      }
    },
  }

</script>

<style lang="scss">
.avatar-uploader .el-upload {
    // border: 1px dashed #d9d9d9;
    // border-radius: 6px;
    // cursor: pointer;
    // position: relative;
    // overflow: hidden;
    // width: 139px;
    // padding-top: 20p;
    // top: 10px;
    border-radius: 6px;
    cursor: pointer;
    position: absolute;
    left: 200px;
    top: -85px;
    overflow: hidden;
    width: 96px;
    height: 36px;
    background: #F66B3D;
    color:#fff;
    font-size: 14px;
    font-weight: normal;
    line-height: 35px;
    &:hover{
      background: #fc8b65;
    }
  }
  .avatar-uploader{
    position: relative;
    float: left;
    // border-radius: 70px;
    z-index: 999;
    // border:1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    
    font-size: 28px;
    color: #8c939d;
    width: 140px;
    height: 140px;
    line-height: 140px;
    text-align: center;
  }
  .avatar {
    width: 140px;
    height: 140px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// Uploadtop.vue?282f3c6c